// @ts-nocheck
import "./ReviewForm.scss";

import { Component, h, render } from "preact";
import { Connect, Provider } from "redux-zero/preact";

import { Button } from "../Button/Button";
import { FieldInput } from "../FieldInput/FieldInput";
import FilesInput from "../FilesInput/FilesInput";
import { LIMITATION_TYPE_ENUM } from "@/api/constants";
import { ProjectLink } from "../ProjectLink/ProjectLink";
import { RatingInput } from "../RatingInput/RatingInput";
import { TextareaInput } from "../TextareaInput/TextareaInput";
import { Theme } from "../Theme";
import actions from "@/store/actions";
import { createReview } from "@api/index";
import { getCustomText } from "@/utils/getCustomText";
import store from "@/store/store";
import { useLimitation } from "@/hooks/useLimitation";
import { useShopSettings } from "@/hooks/useShopSettings";
import { useState } from "preact/hooks";

const mapToProps = ({ products }) => ({ products });

function ReviewForm({ productUid }) {
  const isAllowedReviewsPhotos = useLimitation(
    LIMITATION_TYPE_ENUM.reivewsPhoto
  );

  const isContactFieldsAllowed = useLimitation(
    LIMITATION_TYPE_ENUM.contactFields
  );

  const settings = useShopSettings();

  return (
    <Theme widget="reviewFormWidget">
      <Provider store={store}>
        <Connect mapToProps={mapToProps} actions={actions}>
          {({ products }) => {
            const product = products[productUid];

            if (!product) return null;

            const [state, setState] = useState({
              loading: false,
              success: false,
              error: null,
            });

            const [data, setData] = useState({
              value: 0,
              review: "",
              firstName: "",
              lastName: "",
              images: [],
              email: "",
              phone: "",
            });

            const [validateErrors, setValidateErrors] = useState({
              value: null,
            });

            const onSubmit = (e) => {
              e.preventDefault();

              let isInvalid = false;

              if (!data.value) {
                isInvalid = true;
                setValidateErrors((prev) => ({
                  ...prev,
                  value: "Поставьте оценку",
                }));
              }

              if (
                settings?.contactFields?.showEmailField &&
                isContactFieldsAllowed &&
                !data.email
              ) {
                isInvalid = true;
                setValidateErrors((prev) => ({
                  ...prev,
                  email: "Введите почту",
                }));
              }

              if (
                settings?.contactFields?.showphoneField &&
                isContactFieldsAllowed &&
                !data.phone
              ) {
                isInvalid = true;
                setValidateErrors((prev) => ({
                  ...prev,
                  phone: "Введите номер",
                }));
              }

              if (isInvalid) return;

              setState({
                loading: true,
                success: null,
                error: null,
              });

              createReview(
                {
                  value: data.value,
                  reviewer_name: data.firstName + " " + data.lastName,
                  text: data.review,
                  images: data.images.map((image) => image.id),
                  phone: data.phone,
                  email: data.email,
                },
                product
              )
                .then(() => {
                  setState({
                    loading: false,
                    success: true,
                    error: null,
                  });
                })
                .catch((err) => {
                  setState({
                    loading: false,
                    success: true,
                    error: null,
                  });
                  console.error(err);
                });
            };

            if (state.success) {
              return (
                <div className="CCReviewForm__success t-text">
                  {getCustomText("reviewsSuccess")}
                </div>
              );
            }

            return (
              <div>
                <form className="CCReviewForm" onSubmit={onSubmit}>
                  <div className="CCReviewForm__title t-text">
                    {getCustomText("reviewFormTitle")}
                  </div>

                  <div className="CCReviewForm__input-group">
                    <RatingInput
                      value={data.value}
                      onChange={(val) => {
                        setData((prev) => ({ ...prev, value: val }));
                        setValidateErrors({ value: null });
                      }}
                      validateError={validateErrors.value}
                    />
                  </div>

                  <div className="CCReviewForm__input-group">
                    <TextareaInput
                      value={data.review}
                      onChange={(val) =>
                        setData((prev) => ({ ...prev, review: val }))
                      }
                    />
                  </div>

                  {isAllowedReviewsPhotos && (
                    <div className="CCReviewForm__input-group">
                      <FilesInput
                        value={data.images}
                        onChange={(val) =>
                          setData((prev) => ({ ...prev, images: val }))
                        }
                      />
                    </div>
                  )}

                  {settings?.contactFields?.showEmailField &&
                    isContactFieldsAllowed && (
                      <div className="CCReviewForm__input-group">
                        <FieldInput
                          required
                          type="email"
                          label={getCustomText("reviewFormFields.emailLabel")}
                          value={data.email}
                          hint={getCustomText("reviewFormFields.emailHint")}
                          onChange={(val) =>
                            setData((prev) => ({ ...prev, email: val }))
                          }
                        />
                      </div>
                    )}

                  {settings?.contactFields?.showPhoneField &&
                    isContactFieldsAllowed && (
                      <div className="CCReviewForm__input-group">
                        <FieldInput
                          required
                          type="phone"
                          label={getCustomText("reviewFormFields.phoneLabel")}
                          value={data.phone}
                          hint={getCustomText("reviewFormFields.phoneHint")}
                          onChange={(val) =>
                            setData((prev) => ({
                              ...prev,
                              phone: val.replace(new RegExp("\\D", "gm"), ""),
                            }))
                          }
                        />
                      </div>
                    )}

                  <div className="CCReviewForm__input-group">
                    <FieldInput
                      label={getCustomText("reviewFormFields.firstnameLabel")}
                      value={data.firstName}
                      onChange={(val) =>
                        setData((prev) => ({ ...prev, firstName: val }))
                      }
                      required
                    />
                    <FieldInput
                      label={getCustomText("reviewFormFields.lastnameLabel")}
                      value={data.lastName}
                      onChange={(val) =>
                        setData((prev) => ({ ...prev, lastName: val }))
                      }
                    />
                  </div>

                  <div className="CCReviewForm__submit">
                    <Button disabled={state.loading}>
                      {state.loading
                        ? getCustomText("reviewFormSubmitButtonLoading")
                        : getCustomText("reviewFormSubmitButtonLabel")}
                    </Button>
                  </div>
                </form>

                <ProjectLink />
              </div>
            );
          }}
        </Connect>
      </Provider>
    </Theme>
  );
}

export default ReviewForm;
